export default __webpack_public_path__ + "static/media/gwp7.6d465d8c.png";